// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3369":"36975de1","3684":"f160fc6b","7440":"4543cde0"}[chunkId] + ".chunk.css";
};